<template>
  <div>
    <div v-loading="tjloading" style="width: 1670px; padding: 20px 15px; display: flex; align-items: center">
      <el-card style="margin-right: 7.5px">
        <div style="display: flex; align-items: center; justify-content: center">
          <div style="width: 50%; font-size: 13px; color: #909399">
            <div>{{ $t("DateProfit.todayNum") }}</div>
            <div style="font-size: 28px; text-align: center; color: #409eff; font-weight: bold">
              {{ DataStatisticsInfo["todayNum"] }}
            </div>
            <div style="display: flex; align-items: center; justify-content: center; width: 100%">
              <span>{{ $t("statistics.DateProfit.9398732-0") }}</span>
              <span
                v-if="DataStatisticsInfo['NumsTongbiFH'] == '+'"
                class="el-icon-caret-top"
                style="font-size: 20px; color: #67c23a; margin-left: 30px"
              ></span>
              <span
                v-else-if="DataStatisticsInfo['NumsTongbiFH'] == '-'"
                class="el-icon-caret-bottom"
                style="font-size: 20px; color: #f56c6c; margin-left: 30px"
              ></span>
              <span v-else style="font-size: 12px; margin-left: 30px; margin-right: 3px">{{
                $t("statistics.DateProfit.9398732-1")
              }}</span>
              <span style="font-size: 14px">{{ DataStatisticsInfo["NumsTongbi"] }}%</span>
            </div>
          </div>
          <div style="width: 50%; font-size: 13px; color: #909399">
            <div>{{ $t("DateProfit.todaySales") }}</div>
            <div style="font-size: 28px; text-align: center; color: #409eff; font-weight: bold">
              {{ DataStatisticsInfo["todaySales"] }}
            </div>
            <div style="display: flex; align-items: center; justify-content: center; width: 100%">
              <span>{{ $t("statistics.DateProfit.9398732-0") }}</span>
              <span
                v-if="DataStatisticsInfo['SalesTongbiFH'] == '+'"
                class="el-icon-caret-top"
                style="font-size: 20px; color: #67c23a; margin-left: 30px"
              ></span>
              <span
                v-else-if="DataStatisticsInfo['SalesTongbiFH'] == '-'"
                class="el-icon-caret-bottom"
                style="font-size: 20px; color: #f56c6c; margin-left: 30px"
              ></span>
              <span v-else style="font-size: 12px; margin-left: 30px; margin-right: 3px">{{
                $t("statistics.DateProfit.9398732-1")
              }}</span>
              <span style="font-size: 14px">{{ DataStatisticsInfo["SalesTongbi"] }}%</span>
            </div>
          </div>
        </div>
      </el-card>
      <el-card style="margin-left: 7.5px">
        <div style="display: flex; align-items: center; justify-content: center">
          <div style="width: 50%; font-size: 13px; color: #909399">
            <div>{{ $t("DateProfit.totalNum") }}</div>
            <div style="font-size: 28px; text-align: center; color: #409eff; font-weight: bold">
              {{ DataStatisticsInfo["num"] }}
            </div>
            <div style="display: flex; align-items: center; justify-content: center; width: 100%; color: white">
              <span>{{ $t("statistics.DateProfit.9398732-0") }}</span>
              <span class="el-icon-caret-top" style="font-size: 20px; color: white; margin-left: 30px"></span>
              <span style="font-size: 14px">10%</span>
            </div>
          </div>
          <div style="width: 50%; font-size: 13px; color: #909399">
            <div>{{ $t("DateProfit.totalSales") }}</div>
            <div style="font-size: 28px; text-align: center; color: #409eff; font-weight: bold">
              {{ DataStatisticsInfo["sales"] }}
            </div>
            <div style="display: flex; align-items: center; justify-content: center; width: 100%; color: white">
              <span>{{ $t("statistics.DateProfit.9398732-0") }}</span>
              <span class="el-icon-caret-top" style="font-size: 20px; color: white; margin-left: 30px"></span>
              <span style="font-size: 14px">10%</span>
            </div>
          </div>
        </div>
      </el-card>
    </div>
    <div
      style="
        width: 1638px;
        margin: 0 15px 15px 15px;
        padding: 15px;
        background-color: #f3f3f3;
        display: flow-root;
        border: 1px solid #e7e7e7;
        border-radius: 3px;
      "
    >
      <div class="el-left" style="line-height: 32px; width: 180px; height: 30px; font-size: 15px">
        {{ $t("DateProfit.riyitongji") }}
      </div>
      <div class="el-right" style="width: 1400px">
        <div style="width: 100%; display: flow-root">
          <el-button
            type="primary"
            @click="ExportMachineData"
            size="small"
            icon="el-icon-download"
            style="margin-right: 15px"
            >{{ $t("common.export") }}</el-button
          >
          <el-input
            v-if="isMer"
            :placeholder="$t('statistics.DateProfit.9398732-2')"
            v-model="userName"
            clearable
            style="width: 200px; margin-right: 15px"
            size="small"
            @blur="handlerUsernameBlur"
          >
          </el-input>
          <el-select
            v-model="search.dayType"
            @change="handlerDayTypeChange"
            size="small"
            style="width: 170px; margin-right: 15px"
          >
            <el-option :label="$t('DateProfit.anxiaoshi')" value="1"></el-option>
            <el-option :label="$t('DateProfit.antian')" value="2"></el-option>
            <el-option :label="$t('DateProfit.anyue')" value="3"></el-option>
          </el-select>
          <el-date-picker
            v-model="dateTime"
            size="small"
            :clearable="false"
            :type="search.dayType == 1 ? 'datetimerange' : search.dayType == 2 ? 'daterange' : 'monthrange'"
            :format="search.dayType == 1 ? 'yyyy-MM-dd HH:mm:ss' : search.dayType == 2 ? 'yyyy-MM-dd' : 'yyyy-MM'"
            :value-format="search.dayType == 1 ? 'yyyy-MM-dd HH:mm:ss' : search.dayType == 2 ? 'yyyy-MM-dd' : 'yyyy-MM'"
            range-separator="-"
            :start-placeholder="$t('searchMachineProfit.start')"
            :end-placeholder="$t('searchMachineProfit.end')"
            style="width: 335px; margin-right: 15px"
          ></el-date-picker>
          <!-- 懒加载select -->
          <el-select
            collapse-tags
            multiple
            :multiple-limit="10"
            v-model.trim="allMachine"
            v-el-select-loadmore="handleLoadmore"
            filterable
            remote
            :remote-method="handleAttrValueFilter"
            size="small"
            style="width: 200px; margin-right: 15px"
            :placeholder="$t('MachineProfit.qbjiqi')"
          >
            <el-option
              v-for="(item, index) in options"
              :key="item.equipmentNo"
              :label="item.name"
              :value="item.equipmentNo"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="search.searchType"
            :placeholder="$t('MachineProfit.select')"
            size="small"
            style="width: 170px; margin-right: 15px"
          >
            <el-option :label="$t('MachineProfit.xsliang')" value="num"></el-option>
            <el-option :label="$t('MachineProfit.xshoue')" value="sales"></el-option>
          </el-select>
          <el-button type="primary" @click="handlerSubmitSearch" size="small" icon="el-icon-search">{{
            $t("common.search")
          }}</el-button>
          <el-button @click="handlerResetSearch" size="small" icon="el-icon-refresh">{{
            $t("common.reset")
          }}</el-button>
        </div>
      </div>
    </div>
    <div style="width: 1670px; padding: 15px; display: flow-root">
      <div id="rytjchart"></div>
    </div>
    <div class="vue-padding radius">
      <el-table
        v-loading="loading"
        :empty-text="$t('common.noData')"
        :element-loading-text="$t('common.loading')"
        :data="dateProfitList"
        style="width: 100%"
        max-height="638"
        :border="true"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column
          prop="orderDate"
          :show-overflow-tooltip="true"
          :label="$t('dateOrder.strCreateDate')"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="num"
          :label="$t('dateOrder.allPurchaseNum')"
          width="130"
          :align="'center'"
        ></el-table-column>
        <el-table-column
          prop="sales"
          :label="$t('dateOrder.allDuePrice')"
          width="130"
          :align="'center'"
        ></el-table-column>
      </el-table>
      <el-pagination
        v-if="page.totalSize > 0"
        background
        layout="total,sizes,prev, pager, next,jumper"
        :current-page="page.pageIndex"
        :total="page.totalSize"
        @size-change="sizeChange"
        :page-size="page.pageSize"
        @current-change="CurrentChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import searchDateProfit from "_c/statistics/SearchDateProfit";
  import * as echarts from "echarts";
  let rytjchart = null;
  export default {
    name: "DateProfit",
    components: {
      searchDateProfit
    },
    directives: {
      "el-select-loadmore": {
        //自定义指令
        bind(el, binding) {
          const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
          SELECTWRAP_DOM.addEventListener("scroll", function () {
            const condition = this.scrollHeight - this.scrollTop - 15 <= this.clientHeight;
            if (condition) {
              binding.value();
            }
          });
        }
      }
    },
    data() {
      return {
        userName: "",
        tjloading: false,
        DataStatisticsInfo: {},
        dateProfitList: [],
        search: {
          dayType: "1",
          searchType: "num",
          startDate: "",
          endDate: "",
          equipmentNos: []
        },
        dateTime: [],
        //  树形Tree联合select使用
        MachinesValue: [],
        DefaultProps: {
          children: "children",
          label: "name",
          isLeaf: "leaf"
        },
        page: {
          pageSize: 10,
          pageIndex: 1
        },
        tsearch: {
          startDate: "",
          endDate: ""
        },
        loading: false,
        order: {
          num: 0,
          sales: 0
        },
        isMer: false,
        // 懒加载select1
        allMachine: [],
        selectObj: {
          pageNum: 1,
          pageSize: 10,
          name: ""
        },
        options: [],
        selectLoading: false,
        lock: true
      };
    },
    mounted() {
      let _self = this;
      if (localStorage.utype == 4) {
        this.isMer = true;
      }

      _self.handlerDayTypeChange(_self.search.dayType);
      _self.DataStatistics();
      rytjchart = echarts.init(document.getElementById("rytjchart"), null, {
        width: 1670,
        height: 400
      });
      _self.DayStatisticsData();
      _self.CurrentChange();
      // 首次请求options
      _self.handlerGetSelect();
    },
    methods: {
      // 鼠标移出用户账号输入框
      handlerUsernameBlur() {
        this.selectObj.pageNum = 1;
        this.handlerGetSelect();
      },
      handleLoadmore() {
        //下拉加载
        if (!this.selectLoading) {
          this.handlerGetSelect();
        }
      },
      handleAttrValueFilter(name) {
        //搜索
        console.log(name);
        this.options = [];
        if (!this.selectLoading) {
          this.selectObj.name = name;
          this.selectObj.pageNum = 1;
          this.handlerGetSelect();
        }
      },
      // 请求options
      handlerGetSelect() {
        let that = this;
        if (this.lock) {
          //节流
          that.lock = false;
          let timer = setTimeout(() => {
            clearTimeout(timer);
            that.lock = true;
          }, 300);
        } else {
          return;
        }
        let url = this.$url.MachineProfit.statisticsday2;
        let method = this.$method.get;
        let params = {
          pageIndex: this.selectObj.pageNum,
          equipmentName: this.selectObj.name
        };
        this.$api.request(url, method, params).then(res => {
          if (res.code === 0) {
            if (res.data.records.length > 0) {
              this.selectObj.pageNum++;
            }
            if (res.data.current == 1) {
              this.options = res.data.records;
            } else {
              this.options = this.options.concat(res.data.records);
            }
            this.selectObj.pageSize = res.data.size;
          }
        });
      },
      //  搜索类型查询
      handlerDayTypeChange(value) {
        let _self = this;
        if (parseInt(value) == 1) {
          let myDate = new Date();
          //  当前时间年月日时分秒
          let year = myDate.getFullYear();
          let month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          let day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          let hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          let minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          let second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          let enddatetime = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
          //  30天前的时间
          let ddstian = 1;
          myDate.setTime(myDate.getTime() - 24 * ddstian * 60 * 60 * 1000);
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          //  获取统计数据
          let startdatetime = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
          _self.dateTime = [startdatetime, enddatetime];
        } else if (parseInt(value) == 2) {
          let myDate = new Date();
          //  当前时间年月日时分秒
          let year = myDate.getFullYear();
          let month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          let day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          let hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          let minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          let second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          let enddatetime = year + "-" + month + "-" + day;
          //  30天前的时间
          let ddstian = 31;
          myDate.setTime(myDate.getTime() - 24 * ddstian * 60 * 60 * 1000);
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          //  获取统计数据
          let startdatetime = year + "-" + month + "-" + day;
          _self.dateTime = [startdatetime, enddatetime];
        } else if (parseInt(value) == 3) {
          let myDate = new Date();
          //  当前时间年月日时分秒
          let year = myDate.getFullYear();
          let month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          let day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          let hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          let minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          let second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          let enddatetime = year + "-" + month;
          //  30天前的时间
          let ddstian = 365;
          myDate.setTime(myDate.getTime() - 24 * ddstian * 60 * 60 * 1000);
          year = myDate.getFullYear();
          month = myDate.getMonth() + 1;
          if (parseInt(month) < 10) {
            month = "0" + month;
          }
          day = myDate.getDate();
          if (parseInt(day) < 10) {
            day = "0" + day;
          }
          hour = myDate.getHours();
          if (parseInt(hour) < 10) {
            hour = "0" + hour;
          }
          minute = myDate.getMinutes();
          if (parseInt(minute) < 10) {
            minute = "0" + minute;
          }
          second = myDate.getSeconds();
          if (parseInt(second) < 10) {
            second = "0" + second;
          }
          //  获取统计数据
          let startdatetime = year + "-" + month;
          _self.dateTime = [startdatetime, enddatetime];
        }
      },
      //  获取数据统计
      DataStatistics() {
        let _self = this;
        _self.tjloading = true;
        _self.$api
          .request(_self.$url.DateProfit.getSales, _self.$method.get, {})
          .then(res => {
            _self.tjloading = false;
            if (res.code === 0) {
              const locale = "en-US"; // zh-CN
              const options = { style: "currency", currency: "USD" }; // CNY
              const sales = parseFloat(res.data.sales);
              const formattedsales = new Intl.NumberFormat(locale, options).format(sales);
              res.data.sales = formattedsales;
              let todayNum = parseInt(res.data.todayNum);
              let todayNums = parseInt(res.data.todayNum);
              todayNum = todayNum.toLocaleString();
              res.data.todayNum = todayNum;
              const todaySales = parseFloat(res.data.todaySales);
              let todaySaless = parseFloat(res.data.todaySales);
              const formattedTodaySales = new Intl.NumberFormat(locale, options).format(todaySales);
              res.data.todaySales = formattedTodaySales;
              let num = parseInt(res.data.num);
              num = num.toLocaleString();
              res.data.num = num;
              //  同比增长或减少
              let yesterdayNum = parseInt(res.data.yesterdayNum);
              let NumsTongbi = 0;
              if (yesterdayNum > 0) {
                NumsTongbi = (todayNums - yesterdayNum) / yesterdayNum;
              } else {
                NumsTongbi = todayNums * 0.01;
              }
              NumsTongbi = NumsTongbi * 100;
              res.data.NumsTongbi = NumsTongbi.toFixed(2);
              if (NumsTongbi < 0) {
                res.data.NumsTongbiFH = "-";
                res.data.NumsTongbi = Math.abs(res.data.NumsTongbi);
              } else if (NumsTongbi > 0) {
                res.data.NumsTongbiFH = "+";
              } else {
                res.data.NumsTongbiFH = "";
              }
              //  同比增长或减少
              let yesterdaySales = parseFloat(res.data.yesterdaySales);
              let SalesTongbi = 0;
              if (yesterdaySales > 0) {
                SalesTongbi = (todaySaless - yesterdaySales) / yesterdaySales;
              } else {
                SalesTongbi = todaySaless * 0.01;
              }
              SalesTongbi = SalesTongbi * 100;
              res.data.SalesTongbi = SalesTongbi.toFixed(2);
              if (SalesTongbi < 0) {
                res.data.SalesTongbiFH = "-";
                res.data.SalesTongbi = Math.abs(res.data.SalesTongbi);
              } else if (SalesTongbi > 0) {
                res.data.SalesTongbiFH = "+";
              } else {
                res.data.SalesTongbiFH = "";
              }
              _self.DataStatisticsInfo = res.data;
            }
          })
          .catch(() => {
            _self.tjloading = false;
          });
      },
      //  日期统计数据
      DayStatisticsData() {
        let _self = this;
        let params = {
          searchType: _self.search.searchType,
          type: parseInt(_self.search.dayType)
        };
        if (_self.dateTime && _self.dateTime.length > 0) {
          params.startDate = _self.dateTime[0];
          params.endDate = _self.dateTime[1];
        }
        if (_self.allMachine.length > 0) {
          params.equipmentNos = _self.allMachine.join(",");
        }
        if (_self.userName) {
          params.userName = _self.userName;
        }
        rytjchart.showLoading();
        _self.$api
          .request(_self.$url.DateProfit.day, _self.$method.get, params)
          .then(res => {
            let result = res.data;
            let xAxisData = [];
            let seriesData = [];
            for (let i = 0; i < result.length; i++) {
              let orderDate = result[i]["orderDate"];
              xAxisData.push(orderDate);
              seriesData.push(result[i][_self.search.searchType]);
            }
            let rytjoption = {
              title: {
                text: _self.$t("DateProfit.riyitongjizxt")
              },
              tooltip: {
                trigger: "axis"
              },
              xAxis: {
                type: "category",
                boundaryGap: false,
                data: xAxisData
              },
              yAxis: {
                type: "value"
              },
              series: [
                {
                  name:
                    _self.search.searchType == "num"
                      ? _self.$t("MachineProfit.xsliang")
                      : _self.$t("MachineProfit.xshoue"),
                  data: seriesData,
                  type: "line",
                  areaStyle: {}
                }
              ]
            };
            rytjchart.clear();
            rytjoption && rytjchart.setOption(rytjoption);
            rytjchart.hideLoading();
          })
          .catch(() => {
            rytjchart.hideLoading();
          });
      },
      // 筛选时间是按天与日期关联
      handlerDateIsOk(type, dateArr) {
        if (type == 1) {
          if (!dateArr) {
            this.$message.warning(this.$t("DateProfit.kuaduHour"));
            return false;
          }
          let kuadu = new Date(dateArr[1]).getTime() - new Date(dateArr[0]).getTime();
          if (kuadu >= 259200000) {
            this.$message.warning(this.$t("DateProfit.kuaduHour"));
            return false;
          }
        } else if (type == 2) {
          if (!dateArr) {
            this.$message.warning(this.$t("DateProfit.kuaduDay"));
            return false;
          }
          let kuadu = new Date(dateArr[1]).getTime() - new Date(dateArr[0]).getTime();
          if (kuadu >= 7776000000) {
            this.$message.warning(this.$t("DateProfit.kuaduDay"));
            return false;
          }
        } else if (type == 3) {
          if (!dateArr) {
            this.$message.warning(this.$t("DateProfit.kuaduMonth"));
            return false;
          }
          let kuadu = new Date(dateArr[1]).getTime() - new Date(dateArr[0]).getTime();
          if (kuadu >= 157680000000) {
            this.$message.warning(this.$t("DateProfit.kuaduMonth"));
            return false;
          }
        }
        return true;
      },
      //  提交搜索
      handlerSubmitSearch() {
        let _self = this;
        if (!_self.handlerDateIsOk(_self.search.dayType, _self.dateTime)) {
          return false;
        }
        // let MachinesValue = _self.MachinesValue;
        // _self.search.equipmentNos = [];
        // for (let i = 0; i < MachinesValue.length; i++) {
        //   _self.search.equipmentNos.push(MachinesValue[i]["id"]);
        // }

        _self.DayStatisticsData();
        _self.CurrentChange();
      },
      //  重置搜索
      handlerResetSearch(type) {
        let _self = this;
        _self.search.dayType = "1";
        _self.handlerDayTypeChange(_self.search.dayType);
        _self.allMachine = [];
        _self.search.searchType = "num";
        _self.MachinesValue = [];
        _self.userName = "";
        _self.DayStatisticsData();
        _self.CurrentChange();
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
        this.currentChange();
      },
      // 底部数据表
      CurrentChange(pageIndex) {
        let _self = this;
        _self.loading = true;
        _self.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = _self.$cloud.objMerge(_self.tsearch, _self.page);
        if (_self.dateTime && _self.dateTime.length > 0) {
          obj.startDate = _self.dateTime[0];
          obj.endDate = _self.dateTime[1];
        }
        // 处理日期时间
        console.log(this.search.dayType, 111);
        if (this.search.dayType == 1) {
          //按小时 去除小时
          obj.startDate = obj.startDate.slice(0, obj.startDate.indexOf(" "));
          obj.endDate = obj.endDate.slice(0, obj.endDate.indexOf(" "));
        } else if (this.search.dayType == 3) {
          obj.startDate = obj.startDate + "-01";
          obj.endDate = obj.endDate + "-" + this.getDaysInMonth(+obj.endDate.slice(0, 4), +obj.endDate.slice(5));
        }
        _self.$api
          .request(_self.$url.DateProfit.date, _self.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              _self.dateProfitList = res.data.records;
              _self.order = res.data.sum;
              _self.page.totalSize = parseInt(res.data.total);
            }
            _self.loading = false;
          })
          .catch(() => {
            _self.loading = false;
          });
      },
      // 获取当月日子数目
      getDaysInMonth(year, month) {
        console.log(year, month);
        return new Date(year, month, 0).getDate();
      },
      // 指定列求和
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = <span style="font-weight: bold;">{this.$t("machineRenewal.total")}</span>;
            return;
          }
          if (column.property === "num") {
            sums[index] = <span style="font-weight: bold;">{this.order.num}</span>;
          } else if (column.property === "sales") {
            sums[index] = <span style="font-weight: bold;">{parseFloat(this.order.sales)}</span>;
          }
        });
        return sums;
      },
      ExportMachineData() {
        let _self = this;
        _self
          .$confirm(_self.$t("MachineProfit.export"), _self.$t("common.tip"), {
            confirmButtonText: _self.$t("common.definite"),
            cancelButtonText: _self.$t("common.cancel"),
            type: "warning"
          })
          .then(() => {
            let rData = {};
            if (_self.userName) {
              rData.userName = _self.userName;
            }
            if (_self.allMachine.length > 0) {
              rData.equipmentNos = _self.allMachine;
            }
            if (_self.search.searchType) {
              rData.searchType = _self.search.searchType;
            }
            if (_self.search.dayType) {
              rData.type = _self.search.dayType;
            }
            if (_self.dateTime && _self.dateTime.length > 0) {
              rData.startDate = _self.dateTime[0];
              rData.endDate = _self.dateTime[1];
            }
            if (!_self.handlerDateIsOk(_self.search.dayType, _self.dateTime)) {
              return false;
            }
            rData.lang = this.$cookies.get("lang");
            _self.$api.download(_self.$url.DateProfit.export, rData);
          });
      }
    }
  };
</script>

<style lang="scss" scoped>
  ::v-deep .el-card {
    width: 835px;
    display: flex;
    float: left;
  }
  ::v-deep .el-card__body {
    width: 785.5px;
  }
</style>
